// public/js/modules/map/index.js
// Barrel file for the MapLibre (beta) map module

// State
export {
  mapInstance,
  markers,
  currentFilteredAssets,
  currentOpenPopup,
  currentHistoryPointMarkers,
  currentRouteLayers,
  currentRouteSourceIds,
  resetState,
  closeCurrentPopup
} from './state.js';

// Constants
export {
  typeColors
} from './constants.js';

// Core
export {
  initMap,
  getMapInstance,
  centerOnAsset,
  fitAllMarkers,
  clearAllMapData,
  resizeMapIfNeeded
} from './core.js';

// Markers
export {
  addAssetMarker,
  clearMarkers,
  showAssetPopup
} from './markers.js';

// Clustering
export {
  applyClustering,
  destroyClusterLayers
} from './clustering.js';

// Rendering
export {
  renderFilteredMarkers,
  fitToFilteredAssets
} from './rendering.js';

// History / Route
export {
  clearRoute,
  loadAssetHistoryAndDrawRoute
} from './history.js';

// Simplify (re-exported)
export {
  simplifyRoute,
  findStopIndices,
  SIMPLIFICATION
} from './simplify.js';
